<template>
	<div :class="['wistia-container', {'show-wistia-container': showWistiaPlayerContainer }]">
		<div v-if="!showWistiaPlayer" class="loader"></div>
		<div :class="['wistia-inner-container', {'show-wistia-player': showWistiaPlayer }]">
			<div class="wistia-player">
				<div class="close-wistia-player" v-on:click="closeWistiaPlayer">+</div>
				<iframe
					ref="wistiaIframe"
					v-if="wistiaMediaId"
					:src="`https://fast.wistia.net/embed/iframe/${wistiaMediaId}?web_component=true&seo=true`"
					:title="`${wistiaMediaId} Video`"
					allow="autoplay; fullscreen"
					allowtransparency="true"
					class="wistia_embed"
				></iframe>
			</div>
		</div>
	</div>
</template>
<script setup>
import { useWistiaMediaId } from '~~/composables/useWistiaMediaId';
import { useLoadScriptOnce  } from '~~/composables/useLoadScriptOnce';
import { ref, watch, nextTick } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const wistiaMediaId = useWistiaMediaId();
const { loadScriptOnce } = useLoadScriptOnce();
const props = defineProps({
	wistiaMediaId: {
		type: String,
		default: '', // valeur par défaut vide
	}
});

const wistiaIframe = ref(false);
const showWistiaPlayer = ref(false);
const showWistiaPlayerContainer = ref(false);
const wistiaVideoPlayer = ref(false);

const closeWistiaPlayer = () => {
	let closeTimeout = null

	showWistiaPlayer.value = false;
	showWistiaPlayerContainer.value = false;

	if (closeTimeout) {
		clearTimeout(closeTimeout)
	}

	closeTimeout = setTimeout(() => {
		wistiaMediaId.value = null
		closeTimeout = null
	}, 400);
};

watch(wistiaMediaId, async (newId) => {
	if (!newId) {
		return;
	}

	if (!wistiaMediaId || !process.client) {
		return;
	}

	await loadScriptOnce('https://fast.wistia.com/player.js')
	await loadScriptOnce('https://fast.wistia.com/assets/external/E-v1.js')

	// attendre que l'iframe soit ajouté au DOM
	await nextTick();

	showWistiaPlayerContainer.value = true;

	window._wq = window._wq || [];
	window._wq.push(function (wistia) {
		const userCookieAnalyticsConsent = localStorage.getItem('silktideCookieChoice_analytics') === 'true' ? true : false;

		wistia.consent(userCookieAnalyticsConsent);
	});

	_wq.push({ id: "_all", onReady: function(video) {
		wistiaVideoPlayer.value = video;

		video.play();
		video.bind("play", function() {
			showWistiaPlayer.value = true;
		});
	}});
});

watch(
	() => route.fullPath,() => {
		wistiaMediaId.value = null;
		closeWistiaPlayer();
	}
);
</script>

<style lang="scss">
@use '~/assets/scss/components/WistiaPlayerEmbed';
</style>